export const fetchContentList = async (query: string) => {
  const resp = await fetch(process.env.NEXT_PUBLIC_GRAPHQL_API as string, {
    headers: { apiKey: process.env.NEXT_PUBLIC_GRAPHQL_APIKEY as string },
    method: "POST",
    body: JSON.stringify({
      query: query,
    }),
  });
  const res = await resp.json();
  return res.data;
};
